import { Outlet, useLocation } from 'react-router-dom';
import { Navigation } from './Navigation';
import { DashboardNavigation } from './DashboardNavigation';
import { useAuth } from '../../contexts/AuthContext';
import { cn } from '../../lib/common/utils';
import { Analytics } from '@vercel/analytics/react';
export function Layout() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  const isAuroraRoute = ['/', '/signin', '/signup'].includes(location.pathname);

  const containerBaseClass = "min-h-screen flex flex-col";
  const containerClasses = cn(
    containerBaseClass,
    {
      'aurora-bg': isAuroraRoute,
      'bg-black text-white': !isAuroraRoute,
    }
  );

return (
    <>
      <div className={containerClasses}>
        <div className="transition-all duration-300 fixed top-0 w-full z-10 opacity-100">
          {isAuthenticated ? <DashboardNavigation /> : <Navigation />}
        </div>
        <main className="flex-grow pt-16">
          <Outlet />
        </main>
      </div>
      <Analytics />
    </>
  );
}